import { useMutation, useQueryClient } from "@tanstack/react-query";
import qcareApi from "./qcareApi";
import { GGNLocations } from "../interfaces/intakes.reports";

interface EditMainDataProps {
    reportId: string,
    ggnLocations: GGNLocations[],
}

interface DeleteGGNProps {
    reportId: string,
    ggn_number: string,
}

const sendGGN = async ({reportId, ggnLocations}:EditMainDataProps) => {
    const {data} = await qcareApi.post(`/report/add-ggn/${reportId}`, {ggnLocations})
    return data
};

const deleteGGN = async ({reportId, ggn_number}:DeleteGGNProps) => {
    const {data} = await qcareApi.post(`/report/delete-ggn`, {reportId, ggn_number})
    return data
};

// ------------------------- HOOKS -------------------------

export const useGGNLocations = ( ) => {
    const queryClient = useQueryClient()

    return useMutation(sendGGN, {
        onSuccess: async(data) => {
            await queryClient.invalidateQueries(['report', data.reportId])
        }
    })
}

export const useDeleteGGNLocation = ( ) => {
    const queryClient = useQueryClient()

    return useMutation(deleteGGN, {
        onSuccess: async(data) => {
            await queryClient.invalidateQueries(['report', data.reportId])
        }
    })
}